<template>
    <div :class="{compacted: compacted}" ref="filesystemelement">
        <file-preview></file-preview>
        <div class="filesystem">
            <main :class="{ opened: sidebarOpen }">
                <h1 v-if="filesystemTitle" class="hidden-mobile">Files: {{ filesystemTitle }}</h1>

                <!--Desktop Action Bar-->
                <div class="hidden-mobile">
                    <div class="action-bar">
                        <div class="file-breadcrumbs">
                            <a href="#" @click.prevent="getFromBreadcrumb(crumb)"
                               v-for="crumb in breadcrumbs" class="directory-element" :data-directory-id="crumb.id">{{
                                crumb.name
                                }}</a>
                        </div>
                        <div class="extra-actions">
                            <a href="#" @click.prevent="newFile()"><i class="fa fa-plus"></i> File</a>
                            <a href="#" @click.prevent="newDirectory()"><i class="fa fa-plus"></i> Folder</a>
                            <br/>
                            <a href="#" v-if="viewType == 'icon'" @click.prevent="showListView()"><i
                                    class="fa fa-list"></i> List View</a>
                            <a href="#" v-else @click.prevent="showIconView()"><i
                                    class="fa fa-th-large"></i> Icon View</a>
                        </div>
                    </div>

                    <!-- Search Area -->
                    <div class="search-area">
                        <div>
                            <input type="text" @keyup="performSearchDebounced()"
                                   placeholder="Search Files And Folders..."
                                   v-model="searchQuery"/><a href="#"
                                                             @click.prevent="performSearch()"><i
                                class="fa fa-search"></i></a>
                        </div>
                    </div>
                </div>

                <!--Mobile Action Bar-->
                <div class="hidden-desktop">


                    <div class="action-bar-mobile">

                        <div class="search-area">
                            <input type="text" @keyup.enter="performSearchDebounced()"
                                   placeholder="Search Files And Folders..."
                                   v-model="searchQuery"/>
                            <a href="#" @click.prevent="performSearch()"><i class="fa fa-search"></i></a>
                        </div>

                        <div class="extra-actions">
                            <a href="#" v-if="viewType == 'list'" @click.prevent="showIconView()"><i
                                    class="fa fa-th-large"></i></a>
                            <a href="#" v-if="viewType == 'icon'" @click.prevent="showListView()"><i
                                    class="fa fa-list"></i></a>
                            <a href="#" @click.prevent="newDirectory()"><i class="fa fa-folder"></i></a>
                            <a href="#" @click.prevent="newFile()"><i class="fa fa-plus"></i></a>
                        </div>

                        <div class="file-breadcrumbs">
                            <a href="#" @click.prevent="getFromBreadcrumb(crumb)"
                               v-for="crumb in breadcrumbs">{{ crumb.name
                                }}</a>
                        </div>
                    </div>
                </div>


                <!-- Main Listings Area -->
                <div class="scroller">
                    <ul v-if="viewType == 'icon'" class="filesystem-resource-icons">
                        <li v-for="directory in directories" class="filesystem-directory directory-element"
                            :class="{ active: isSelected('directory',directory) }"
                            :data-directory-id="directory.id">
                            <div>
                                <img @click.prevent="selectDirectory(directory,false,$event)" src="/img/folder.png"/>
                                <span v-if="directory.count > 0" class="directory-counter">{{ directory.count }}</span>
                                <a href="#" @click.prevent="getDirectory(directory)">{{ directory.name }}</a>
                            </div>
                        </li>
                        <li v-for="file in files" class="filesystem-file file-element"
                            :class="{ active: isSelected('file',file) }"
                            :data-file-id="file.id"
                            @click="selectFile(file,false,$event)">
                            <div>
                                <img v-if="file.has_preview" :src="file.preview_url"/>
                                <i v-else class="fa" :class="file.icon"></i>
                                <span v-if="file.revisions.data.length > 0" class="version-counter">{{ file.revisions.data.length }}</span>
                                <a @click.prevent="previewOrDownloadFile(file)">{{ file.filename }}</a>
                            </div>
                        </li>
                    </ul>

                    <ul v-else class="filesystem-resource-list">
                        <li v-for="directory in directories" :class="{ active: isSelected('directory',directory) }"
                            @click.prevent="selectDirectory(directory,false,$event)">

                            <div class="image">
                                <img src="/img/folder.png"/>
                            </div>
                            <div class="resource-name">
                                <a href="#" @click.prevent="getDirectory(directory)">{{ directory.name }}</a>
                                <small>{{ directory.count }} Items</small>
                            </div>
                            <div class="resource-arrow">
                                <i class="fa fa-chevron-right"></i>
                            </div>

                        </li>

                        <li v-for="file in files" :class="{ active: isSelected('file',file) }"
                            @click="selectFile(file,false,$event)">

                            <div class="image">
                                <img v-if="file.has_preview" :src="file.preview_url"/>
                                <i v-else class="fa" :class="file.icon"></i>
                            </div>
                            <div class="resource-name">
                                <a href="#" @click.prevent="previewOrDownloadFile(file)">{{ file.filename }}
                                    <small v-if="file.revisions.data.length > 0"> ({{ file.revisions.data.length }}
                                        Revisions)
                                    </small>
                                </a>
                            </div>
                            <div class="resource-arrow">
                                <i class="fa fa-chevron-right"></i>
                            </div>

                        </li>
                    </ul>
                </div>


            </main>
            <aside v-if="!sidebarOpen" class="hidden-mobile hidden-compacted dropzone-aside">
                <!-- Upload New File Sidebar Area -->
                <div>
                    <div>
                        <h1>Upload New File</h1>
                        <p class="hidden-mobile">Drag a file onto the box below or anywhere in the filesystem area. Alternatively click the box below to manually choose a file.</p>
                        <p class="hidden-desktop">Tap the box below to choose a file to upload.</p>
                        <crud-errors :errors="errors"></crud-errors>
                        <dropzone :filesystem-id="filesystemId" :directory-id="directoryIdForUploads"></dropzone>
                    </div>
                </div>
            </aside>

            <aside v-else class="opened">

                <div>
                    <a href="#" v-if="!searchOpen || (searchOpen && selected === null)" title="Back To Listings"
                       @click.prevent="clearEntireSidebar()"
                       class="hidden-desktop visible-compacted back-to-listings-button"><i
                            class="fa fa-chevron-left"></i></a>

                    <!-- Directory Overview Selection Sidebar Area -->
                    <div v-if="selectedType == 'multiple'">
                        <i class="sidebar-detail-font-icon fa fa-server"></i>

                        <h1>{{ selected.length }} Items Selected</h1>

                        <ul>
                            <li v-for="item in selected">
                                <div v-if="item.entity_type == 'file'">
                                    <i class="fa fa-file"></i> {{ item.filename }}
                                </div>
                                <div v-if="item.entity_type == 'directory'">
                                    <i class="fa fa-folder"></i> {{ item.name }}
                                </div>
                            </li>
                        </ul>

                        <a class="item-action-button warning" href="#" @click.prevent="deleteSelected(selected)"><i
                                class="fa fa-trash"></i> Delete All {{ selected.length }} Items</a>
                        <a class="item-action-button warning" href="#" @click.prevent="downloadSelected(selected)"><i
                                class="fa fa-cloud"></i> Download Items As ZIP</a>
                        <a class="item-action-button" href="#" @click.prevent="makePrivate(selected)"><i
                                class="fa fa-lock"></i> Make Private</a>
                        <a class="item-action-button" href="#" @click.prevent="makePublic(selected)"><i
                                class="fa fa-eye"></i> Make Public</a>
                    </div>

                    <!-- Directory Overview Selection Sidebar Area -->
                    <div v-if="selectedType == 'directory'">
                        <a href="#" v-if="searchOpen" title="Back To Search Results" @click.prevent="unselectAll()"
                           class="back-to-search-results-button"><i class="fa fa-chevron-left"></i></a>

                        <img src="/img/folder.png" class="sidebar-detail-icon"/>
                        <h1>{{ selected.name }}</h1>

                        <dl class="attribute-list">
                            <dt>Created By:</dt>
                            <dd>{{ selected.created_by }}</dd>
                            <dt>Created At:</dt>
                            <dd>{{ selected.created_at }}</dd>
                        </dl>

                        <a class="item-action-button warning" href="#" @click.prevent="deleteDirectory(selected)"><i
                                class="fa fa-trash"></i> Delete Folder</a>
                    </div>

                    <!-- Upload New File Sidebar Area -->
                    <div v-if="new_file !== null">
                        <h1 class="pad-left">Upload New File</h1>
                        <p class="hidden-mobile">Drag a file onto the box below or anywhere in the filesystem area. Alternatively click the box below to manually choose a file.</p>
                        <p class="hidden-desktop">Tap the box below to choose a file to upload.</p>
                        <crud-errors :errors="errors"></crud-errors>

                        <dropzone :filesystem-id="filesystemId" :directory-id="directoryIdForUploads"></dropzone>
                    </div>

                    <!-- File Overview Selection Sidebar Area -->
                    <div v-if="selectedType == 'file'">
                        <a href="#" v-if="searchOpen" title="Back To Search Results" @click.prevent="unselectAll()"
                           class="back-to-search-results-button"><i class="fa fa-chevron-left"></i></a>

                        <img v-if="selected.has_preview" :src="selected.preview_url"
                             class="sidebar-detail-icon sidebar-detail-image"/>
                        <i v-else class="sidebar-detail-font-icon fa" :class="selected.preview_url"></i>
                        <h1>{{ selected.filename }}</h1>

                        <dl class="attribute-list">
                            <dt>Uploaded By:</dt>
                            <dd>{{ selected.created_by }}</dd>
                            <dt>Uploaded At:</dt>
                            <dd>{{ selected.created_at }}</dd>
                            <dt v-if="selected.revisions.data.length">Revisions</dt>
                            <dd v-if="selected.revisions.data.length">
                                <div v-for="revision in selected.revisions.data" class="changelog">
                                    <h4>Changed By {{ revision.created_by }} On {{ revision.created_at }}</h4>
                                    <p>{{ revision.changes }}</p>
                                    <a :href="revision._links.download">Download</a>
                                </div>
                            </dd>
                        </dl>

                        <a class="item-action-button" href="#" @click.prevent="downloadFile(selected)"><i
                                class="fa fa-cloud"></i> Download File</a>
                        <a class="item-action-button warning" href="#" @click.prevent="deleteFile(selected)"><i
                                class="fa fa-trash"></i> Delete File</a>
                    </div>

                    <!-- Create New Directory Sidebar Area -->
                    <div v-if="new_directory !== null">
                        <h1 class="pad-left">Create New Folder</h1>
                        <crud-errors :errors="errors"></crud-errors>
                        <dl>
                            <dt>New Folder Name</dt>
                            <dd><input type="text" placeholder="New folder name..."
                                       @keyup.enter.prevent="createNewDirectory()" v-model="new_directory"/></dd>
                        </dl>
                        <a class="item-action-button" href="#" @click.prevent="createNewDirectory()"><i
                                class="fa fa-plus-square-o"
                                aria-hidden="true"></i>
                            Create Folder</a>
                    </div>

                    <!-- Search Results Sidebar Area -->
                    <div v-if="searchOpen && selected === null">
                        <h1 class="pad-left">Search Results For "{{ searchQuery }}"</h1>

                        <h4>Files:</h4>
                        <ul class="filesystem-resource-list">

                            <li v-for="file in files" :class="{ active: isSelected('file',file) }"
                                @click="selectFile(file,false,$event)">

                                <div class="image">
                                    <img v-if="file.has_preview" :src="file.preview_url"/>
                                    <i v-else class="fa" :class="file.preview_url"></i>
                                </div>
                                <div class="resource-name">
                                    <a href="#" @click.prevent="previewOrDownloadFile(file)">{{ file.filename }}</a>
                                </div>
                                <div class="resource-arrow">
                                    <i class="fa fa-chevron-right"></i>
                                </div>

                            </li>
                        </ul>

                        <h4>Folders:</h4>
                        <ul class="filesystem-resource-list">
                            <li v-for="directory in searchResults.directories"
                                :class="{ active: isSelected('directory',directory) }"
                                @click.prevent="selectDirectory(directory,false,$event)">

                                <div class="image">
                                    <img src="/img/folder.png"/>
                                </div>
                                <div class="resource-name">
                                    <a href="#" @click.prevent="getDirectory(directory)">{{ directory.name }}</a>
                                    <small>{{ directory.count }} Items</small>
                                </div>
                                <div class="resource-arrow">
                                    <i class="fa fa-chevron-right"></i>
                                </div>

                            </li>

                            <li v-for="file in searchResults.files" :class="{ active: isSelected('file',file) }"
                                @click="selectFile(file,false,$event)">

                                <div class="image">
                                    <img v-if="file.has_preview" :src="file.preview_url"/>
                                    <i v-else class="fa" :class="file.preview_url"></i>
                                </div>
                                <div class="resource-name">
                                    <a href="#" @click.prevent="previewOrDownloadFile(file)">{{ file.filename }}</a>
                                </div>
                                <div class="resource-arrow">
                                    <i class="fa fa-chevron-right"></i>
                                </div>

                            </li>
                        </ul>

                    </div>

                </div>
            </aside>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['filesystemId', 'filesystemTitle', 'compact'],
        data() {
            return {
                viewType: "icon",
                files: [],
                errors: null,
                new_directory: null,
                new_file: null,
                selected: null,
                selectedType: null,
                directories: [],
                breadcrumbs: [],
                searchResults: {
                    files: [],
                    directories: []
                },
                searchOpen: false,
                loading: false,
                searchQuery: '',
                delay: 400,
                clicks: 0,
                timer: null
            }
        },
        computed: {
            directoryIdForUploads: function(){
              if (!_.isUndefined(this.lastCrumb) && this.lastCrumb.type === "directory") {
                return this.lastCrumb.id;
              }

              return '';
            },
            lastCrumb: function () {
                return this.breadcrumbs[this.breadcrumbs.length - 1];
            },
            compacted() {
                if (this.compact == "true") {
                    return true;
                }

                return false;
            },
            hasSelection: function () {
                return _.isObject(this.selected) || _.isArray(this.selected) || _.isString(this.new_directory) || _.isString(this.new_file);
            },
            sidebarOpen: function () {
                if (this.hasSelection) {
                    return true;
                }

                if (this.new_directory !== null || this.new_file !== null) {
                    return true;
                }

                return this.searchOpen;
            }
        },
        watch: {
            files: function () {
                this.setupDroppables();
            },
            directories: function () {
                this.setupDroppables();
            },
            breadcrumbs: function () {
                this.setupDroppables();
            },
            filesystemId: function(){
                this.init();
            }
        },
        methods: {
            setupDroppables: _.debounce(function () {
                var that = this;
                $(".file-element").draggable({
                    // cancel: "a", // clicking an icon won't initiate dragging
                    revert: "invalid", // when not dropped, the item will revert back to its initial position
                    cursor: "move"
                });
                $(".directory-element").draggable();
                $(".directory-element").droppable({
                    tolerance: "pointer",
                    over: function (event, ui) {
                        $(ui.draggable).css('opacity', 0.2);
                        $(this).css('background-color', '#ebf2f6');
                        $(this).css('border', '2px solid #AC0000');
                        $(this).css('border-radius', '0.3em');
                    },
                    out: function (event, ui) {
                        $(ui.draggable).css('opacity', 1);
                        $(this).css('border', 'none');
                        $(this).css('background-color', 'transparent');
                    },
                    drop: function (event, ui) {
                        var newDirectoryId = $(this).attr('data-directory-id');
                        var draggableType = ($(ui.draggable).hasClass('directory-element') ? 'directory' : 'file');
                        var draggableId = ($(ui.draggable).hasClass('directory-element') ? $(ui.draggable).attr('data-directory-id') : $(ui.draggable).attr('data-file-id'));

                        var elementToKill = $(ui.draggable);

                        axios.put(appUrls.files.move, {
                            to_move_id: draggableId,
                            to_move_type: draggableType,
                            move_to_id: newDirectoryId,
                            fs: that.filesystemId
                        }).then(function () {
                            that.refreshCurrentList();
                        });

                    }
                });
            }, 1000),
            previewOrDownloadFile(file) {
                if (file.has_preview) {
                    var previewUrl = file.big_preview_url;
                    if(file.is_pdf){
                      var previewUrl = file._links.inline;
                    }
                    eventBus.$emit('file-preview-modal-open', file.filename, previewUrl, this.files.findIndex(function (loopedFile) {
                        return loopedFile.id === file.id;
                    }), file.is_pdf);
                } else {
                    window.location.href = file._links.download;
                }
            },
            downloadFile(file){
                window.location.href = file._links.download;
            },
            resetErrors: function () {
                this.errors = null;
            },
            setVisibility(selected, type) {
                var requirements = {
                    files: [],
                    dirs: []
                };

                _.forEach(selected, function (select) {
                    if (select.entity_type == 'file') {
                        requirements.files.push(select.id);
                    } else {
                        requirements.dirs.push(select.id);
                    }
                });

                if (type == 'public') {
                    var url = appUrls.files.visibility.set_public;
                } else {
                    var url = appUrls.files.visibility.set_private;
                }

                var that = this;

                axios.put(url, requirements).then(function () {
                    that.refreshCurrentList();
                });
            },
            makePrivate(selected) {
                this.setVisibility(selected, 'private');
            },
            makePublic(selected) {
                this.setVisibility(selected, 'public');
            },
            performSearch() {
                var url = appUrls.files.search.replace('REPLACEME', this.filesystemId);
                var that = this;
                this.loading = true;
                this.clearEntireSidebar();

                axios.get(url, {params: {'query': this.searchQuery}})
                    .then(response => {
                        that.loading = false;
                        this.showSearchResults(response.data.data.files.data, response.data.data.directories.data);
                    });
            },
            performSearchDebounced: _.debounce(function () {
                this.performSearch();
            }, 1),
            showSearchResults(files, directories) {
                this.clearEntireSidebar();
                this.searchResults.files = files;
                this.searchResults.directories = directories;
                this.searchOpen = true;
            },
            isSelected(type, item) {
                if (this.hasSelection) {
                    if (this.selectedType == type && this.selected.id === item.id) {
                        return true;
                    }
                    if (_.isArray(this.selected)) {
                        var exists = false;
                        _.forEach(this.selected, function (selectedItem) {
                            if (selectedItem.id === item.id && type === selectedItem.entity_type) {
                                exists = true;
                            }
                        });
                        if (exists) {
                            return true;
                        }
                    }
                }

                return false;
            },
            clearEntireSidebar(retainResults) {
                this.resetErrors();
                this.unselectAll();
                this.new_directory = null;
                this.new_file = null;
                if (!retainResults) {
                    this.searchOpen = false;
                    this.searchResults.files = [];
                    this.searchResults.directories = [];
                }

                document.onkeydown = null;
            },
            selectMultiple(item) {
                document.onkeydown = null;
                if (!_.isArray(this.selected)) {
                    this.selected = [this.selected];
                }

                if (this.selectionExistsInSelectedArray(item)) {
                    this.removeSelectedItemFromSelectedList(item);
                } else {
                    this.selected.push(item);
                    this.selectedType = 'multiple';
                }

                this.selected = _.uniqBy(this.selected, function (selectedItem) {
                    return selectedItem.entity_type + '_' + selectedItem.id;
                });

                if (_.isEmpty(this.selected)) {
                    this.unselectAll();
                }
            },
            selectMultipleBetween(item) {
                document.onkeydown = null;
                if (this.selectionExistsInSelectedArray(item)) {
                    this.selectMultiple(item);
                } else {
                    this.selectMultiple(item);
                    if (this.selected.length > 1) {
                        var previouslySelected = this.selected[this.selected.length - 2];
                        if (previouslySelected.entity_type == 'directory' && item.entity_type == 'directory') {
                            var newSelectionIndex = this.directories.indexOf(item);
                            var previousSelectionIndex = this.directories.indexOf(previouslySelected);
                            if (newSelectionIndex > previousSelectionIndex) {
                                var operatingIndex = previousSelectionIndex + 1;
                                while (operatingIndex < newSelectionIndex) {
                                    this.selectMultiple(this.directories[operatingIndex]);
                                    operatingIndex++;
                                }
                            } else {
                                var operatingIndex = previousSelectionIndex - 1;
                                while (operatingIndex > newSelectionIndex) {
                                    this.selectMultiple(this.directories[operatingIndex]);
                                    operatingIndex--;
                                }
                            }
                        } else if (previouslySelected.entity_type == 'directory' && item.entity_type == 'file') {
                            var operatingIndex = this.directories.indexOf(previouslySelected) + 1;
                            while (operatingIndex <= (this.directories.length - 1)) {
                                this.selectMultiple(this.directories[operatingIndex]);
                                operatingIndex++;
                            }

                            var operatingIndex = 0;
                            while (operatingIndex < (this.files.indexOf(item))) {
                                this.selectMultiple(this.files[operatingIndex]);
                                operatingIndex++;
                            }
                        } else if (previouslySelected.entity_type == 'file' && item.entity_type == 'file') {
                            var newSelectionIndex = this.files.indexOf(item);
                            var previousSelectionIndex = this.files.indexOf(previouslySelected);
                            if (newSelectionIndex > previousSelectionIndex) {
                                var operatingIndex = previousSelectionIndex + 1;
                                while (operatingIndex < newSelectionIndex) {
                                    this.selectMultiple(this.files[operatingIndex]);
                                    operatingIndex++;
                                }
                            } else {
                                var operatingIndex = previousSelectionIndex - 1;
                                while (operatingIndex > newSelectionIndex) {
                                    this.selectMultiple(this.files[operatingIndex]);
                                    operatingIndex--;
                                }
                            }
                        } else if (previouslySelected.entity_type == 'file' && item.entity_type == 'directory') {

                            var operatingIndex = this.directories.indexOf(item) + 1;
                            while (operatingIndex <= (this.directories.length - 1)) {
                                this.selectMultiple(this.directories[operatingIndex]);
                                operatingIndex++;
                            }

                            var operatingIndex = this.files.indexOf(previouslySelected) - 1;
                            while (operatingIndex >= 0) {
                                this.selectMultiple(this.files[operatingIndex]);
                                operatingIndex--;
                            }
                        }
                    }
                }
            },
            removeSelectedItemFromSelectedList(item) {
                this.selected = _.filter(this.selected, function (selectedItem) {
                    return !(selectedItem.id === item.id && selectedItem.entity_type === item.entity_type);
                });
            },
            selectionExistsInSelectedArray(item) {
                var exists = false;
                _.forEach(this.selected, function (selectedItem) {
                    if (selectedItem.id === item.id && selectedItem.entity_type === item.entity_type) {
                        exists = true;
                    }
                });
                return exists;
            },
            selectDirectory(item, retainResults, e) {
                if (!this.hasSelection) {
                    this.clearEntireSidebar(retainResults);
                }
                document.onkeydown = null;


                if ((e.metaKey || e.ctrlKey) && !_.isNull(this.selected)) {
                    this.selectMultiple(item);
                } else if (e.shiftKey) {
                    this.selectMultipleBetween(item);
                } else {
                    this.clicks++;
                    if (this.clicks === 1) {
                        var self = this;
                        this.timer = setTimeout(function () {
                            if (self.clicks > 0) {
                                self.selected = item;
                                self.selectedType = 'directory';
                                var that = self;
                                var currentIndex = self.directories.findIndex(x => x.id == item.id);
                                var canGoForward = (currentIndex + 1) < self.directories.length;
                                var canGoBack = currentIndex > 0;

                                document.onkeydown = checkKey;

                                function checkKey(e) {
                                    e = e || window.event;
                                    if (e.keyCode == '37') {
                                        // Go back!
                                        if (!canGoBack) {
                                            return null;
                                        }
                                        that.selectDirectory(that.directories[currentIndex - 1], false, e);
                                    } else if (e.keyCode == '39') {
                                        // Go forth!
                                        if (!canGoForward) {
                                            return null;
                                        }
                                        that.selectDirectory(that.directories[currentIndex + 1], false, e);
                                    }
                                }
                            }
                            self.clicks = 0;
                        }, this.delay);
                    } else {
                        this.clicks = 0;
                        clearTimeout(this.timer);
                        this.getDirectory(item);
                    }

                }
            },
            selectFile(item, retainResults, e) {
                if (!this.hasSelection) {
                    this.clearEntireSidebar(retainResults);
                }

                if ((e.metaKey || e.ctrlKey) && !_.isNull(this.selected)) {
                    this.selectMultiple(item);
                } else if (e.shiftKey) {
                    this.selectMultipleBetween(item);
                } else {
                    this.clicks++;
                    if (this.clicks === 1) {
                        var that = this;
                        this.timer = setTimeout(function () {
                            if (that.clicks > 0) {
                                that.selected = item;
                                that.selectedType = 'file';
                                var currentIndex = that.files.findIndex(x => x.id == item.id);
                                var canGoForward = (currentIndex + 1) < that.files.length;
                                var canGoBack = currentIndex > 0;

                                document.onkeydown = checkKey;

                                function checkKey(e) {
                                    e = e || window.event;
                                    if (e.keyCode == '37') {
                                        // Go back!
                                        if (!canGoBack) {
                                            return null;
                                        }
                                        that.selectFile(that.files[currentIndex - 1], false, e);
                                    } else if (e.keyCode == '39') {
                                        // Go forth!
                                        if (!canGoForward) {
                                            return null;
                                        }
                                        that.selectFile(that.files[currentIndex + 1], false, e);
                                    }
                                }
                            }
                            that.clicks = 0;
                        }, this.delay);
                    } else {
                        this.clicks = 0;
                        clearTimeout(this.timer);
                        this.previewOrDownloadFile(item);
                    }
                }
            },
            unselectAll() {
                this.selected = null;
                this.selectedType = null;
            },

            newDirectory() {
                this.clearEntireSidebar();
                this.new_directory = '';
            },
            newFile() {
                var that = this;
                this.clearEntireSidebar();
                this.new_file = '';
            },
            showListView() {
                this.viewType = "list";
                axios.put(appUrls.files.view_type, {type: "list"});
            },
            showIconView() {
                this.viewType = "icon";
                axios.put(appUrls.files.view_type, {type: "icon"});
            },
            resetBreadcrumbs() {
                this.breadcrumbs = [{
                    type: "filesystem",
                    name: "Home",
                    id: null
                }];
            },
            refreshCurrentList(toRunAfter) {
                this.clearEntireSidebar();
                if (this.lastCrumb.type == 'filesystem') {
                    this.getFilesystem(toRunAfter);
                } else {
                    this.getDirectory(this.lastCrumb.id, toRunAfter);
                }

                return;
            },
            createNewDirectory() {
                var that = this;
                var data = {
                    filesystem: this.filesystemId,
                    name: this.new_directory
                };

                this.resetErrors();

                if (this.lastCrumb.type == "directory") {
                    data["directory"] = this.lastCrumb.id;
                }

                var url = appUrls.files.create.directory;

                axios.post(url, data)
                    .then(response => {
                        that.new_directory = null;
                        var directoryToSelect = response.data.data;
                        that.refreshCurrentList(function () {
                            that.selected = directoryToSelect;
                            that.selectedType = "directory";
                        });


                    }).catch(function (error) {
                    if (error.response.status === 422) {
                        that.errors = error.response.data.errors;
                    }
                });
            },
            deleteFile(file) {
                var that = this;
                var title = 'Are you sure you want to delete the file "' + file.filename + '"?';
                var description = 'Deleting this file will remove it completely and is irreversible. Are you sure you want to delete it?';

                eventBus.$emit('delete-modal-open', title, description, function () {
                    var url = appUrls.files.delete.file.replace('REPLACEME', file.id);

                    // Remove this task from the list of tasks in the system.
                    that.files.splice(that.files.indexOf(file), 1);
                    that.clearEntireSidebar();

                    axios.delete(url);
                });
            },
            downloadSelected(selected) {
                if (_.isArray(selected)) {
                    var requirements = {
                        files: [],
                        dirs: []
                    };

                    _.forEach(selected, function (select) {
                        if (select.entity_type == 'file') {
                            requirements.files.push(select.id);
                        } else {
                            requirements.dirs.push(select.id);
                        }
                    });

                    var url = appUrls.files.download;
                    axios.get(url, {
                        params: requirements
                    }).then(function(response){
                      window.location.href = response.data.data.url;
                    });
                }
            },
            deleteSelected(selected) {
                var that = this;
                if (_.isArray(selected)) {
                    _.forEach(selected, function (select) {
                        if (select.entity_type == 'file') {
                            var url = appUrls.files.delete.file.replace('REPLACEME', select.id);
                            that.files.splice(that.files.indexOf(select), 1);
                            axios.delete(url);
                        } else {
                            var url = appUrls.files.delete.directory.replace('REPLACEME', select.id);
                            axios.delete(url);
                            that.directories.splice(that.directories.indexOf(select), 1);
                        }
                    });


                    that.clearEntireSidebar();
                }
            },
            deleteDirectory(directory) {
                var that = this;
                var title = 'Are you sure you want to delete the folder "' + directory.name + '"?';
                var description = 'Deleting this folder will remove all files below it and is irreversible. Are you sure you want to delete it?';

                eventBus.$emit('delete-modal-open', title, description, function () {
                    var url = appUrls.files.delete.directory.replace('REPLACEME', directory.id);
                    axios.delete(url);

                    // Remove this task from the list of tasks in the system.
                    that.directories.splice(that.directories.indexOf(directory), 1);
                    that.clearEntireSidebar();

                });
            },
            addBreadcrumb(directory) {
                var exists = _.find(this.breadcrumbs, function (crumb) {
                    return directory.id === crumb.id;
                });

                if (_.isUndefined(exists)) {
                    this.breadcrumbs.push({
                        type: "directory",
                        name: directory.name,
                        id: directory.id
                    });
                }
            },
            getFromBreadcrumb(breadcrumb) {
                if (breadcrumb.type === "filesystem") {
                    this.resetBreadcrumbs();
                    this.getFilesystem();
                } else {
                    var keepItems = true;
                    this.breadcrumbs = _.filter(this.breadcrumbs, function (crumb) {
                        if (crumb.id == breadcrumb.id) {
                            keepItems = false;
                            return true;
                        }

                        return keepItems;
                    });
                    this.getDirectory(breadcrumb.id);
                }
            },
            getDirectory(directory, toRunAfter) {
                var id = directory;
                if (_.isObject(directory)) {
                    this.addBreadcrumb(directory);
                    id = directory.id;
                }

                var url = appUrls.files.directories.replace('REPLACEME', id);
                var that = this;
                this.resetFilesAndDirectories();
                this.loading = true;
                this.clearEntireSidebar();

                axios.get(url)
                    .then(response => {
                        that.addBreadcrumb(response.data.data);
                        that.loading = false;
                        that.clearEntireSidebar();
                        that.setFiles(response.data.data.files.data);
                        that.directories = response.data.data.directories.data;
                        if (_.isFunction(toRunAfter)) {
                            toRunAfter();
                        }
                    });
            },
            setFiles(files) {
                var that = this;
                this.files = [];
                _.forEach(files, function (file) {

                    if (file.previewable && !file.has_preview) {
                        axios.get(file.preview_url);
                        window.setTimeout(function () {
                            console.log("File should be ready now: " + file);
                            file.has_preview = true;
                            that.files.push(file);
                        }, 3500);
                    } else {
                        that.files.push(file);
                    }
                })
            },
            resetFilesAndDirectories() {
                this.files = [];
                this.directories = [];
            },
            getFilesystem(toRunAfter) {
                var url = appUrls.files.filesystem.replace('REPLACEME', this.filesystemId);
                var that = this;
                this.resetFilesAndDirectories();
                this.loading = true;
                this.clearEntireSidebar();

                axios.get(url)
                    .then(response => {
                        that.loading = false;
                        that.clearEntireSidebar();
                        that.setFiles(response.data.data.files.data);
                        that.directories = response.data.data.directories.data;
                        if (_.isFunction(toRunAfter)) {
                            toRunAfter();
                        }
                    });
            },
            previewNextFile: function (currentIndex) {
                var nextIndex = currentIndex + 1;
                if (typeof this.files[nextIndex] === 'undefined') {
                    return;
                }
                else if (this.files[nextIndex].is_previewable != true) {
                    this.previewNextFile(nextIndex);
                    return;
                }

                this.previewOrDownloadFile(this.files[nextIndex]);
            },
            previewPreviousFile: function (currentIndex) {
                var nextIndex = currentIndex - 1;
                if (typeof this.files[nextIndex] === 'undefined') {
                    return;
                }
                else if (this.files[nextIndex].is_previewable != true) {
                    this.previewPreviousFile(nextIndex);
                    return;
                }

                this.previewOrDownloadFile(this.files[nextIndex]);
            },
            init: function(){
                this.resetBreadcrumbs();
                this.getFilesystem();
                var that = this;
                if (appData.user.filesystem_type == 'icon') {
                    this.viewType = 'icon';
                } else {
                    this.viewType = 'list';
                }

                window.eventBus.$on('file-preview-modal-next', function (currentIndex) {
                    that.previewNextFile(currentIndex);
                });

                window.eventBus.$on('file-preview-force-download', function (currentIndex) {
                    that.downloadFile(that.files[currentIndex]);
                });

                window.eventBus.$on('file-preview-modal-previous', function (currentIndex) {
                    that.previewPreviousFile(currentIndex);
                });

                window.eventBus.$on('crud-errors-dismissed', function () {
                    that.errors = null;
                });

                var scrollTimer = -1;

                $('#app').on('scroll', function () {
                    if (scrollTimer != -1) {
                        window.clearTimeout(scrollTimer);
                    }

                    scrollTimer = window.setTimeout(function () {
                        $('.filesystem aside').each(function (elem) {
                            $(this).animate({
                                "margin-top": $('#app').scrollTop() + 'px',
                            }, 50);
                        });
                    }, 150);
                });

                let pdfJsScript = document.createElement('script')
                pdfJsScript.setAttribute('src', '//mozilla.github.io/pdf.js/build/pdf.js');
                document.head.appendChild(pdfJsScript)
            }
        },
        mounted() {
            var that = this;
            this.init();

            var filesystemElement = $(this.$refs.filesystemelement);
            var resetComponentStyles = function(){
              filesystemElement.css('border','none');
            }

            eventBus.$on('dropzone-event-dragleave',resetComponentStyles);
            eventBus.$on('dropzone-event-dragend',resetComponentStyles);
            eventBus.$on('dropzone-event-drop',resetComponentStyles);

            eventBus.$on('dropzone-event-dragenter',function(){
              filesystemElement.css('border-radius','0.3em');
              filesystemElement.css('border','4px solid #AC0000');
            });

            eventBus.$on('dropzone-event-queuecomplete',function(){
              window.setTimeout(function(){
                that.resetErrors();
                that.refreshCurrentList();
              },500);
            });
        }
    }
</script>

<style lang="scss" scoped>
    .filesystem {
        @include grid-collapse();
        @include clearfix();
        > main {
            background-color: #FFF;
            border-radius: $standardBorderRadius;
            padding: 1em;
        }
        > main {
            @include grid-column(4);
            .compacted & {
                @include grid-column(12);
            }
            @include mobile() {
                @include grid-column(12);
            }
            &.opened {
                .compacted & {
                    display: none;
                }
                @include mobile() {
                    display: none;
                }
            }
        }
        > aside {
            display: none;
            &.opened {
                @include grid-column(8);
               // max-width: calc(66.66666% - 26.66667px - 62px);

                display: block;
                position: relative;
                @include mobile() {
                    @include grid-column(12);
                    max-width: unset;
                }
                .compacted & {
                    @include grid-column(12);
                    max-width: unset;
                }
            }

            > div {
                background-color: #FFF;
                border-radius: $standardBorderRadius;
                padding: 1em;
                @include clearfix();
                @include mobile() {
                    position: relative;
                }
                .compacted & {
                    position: relative;
                }
                div {
                    position: relative;
                }
            }
        }

        > aside.dropzone-aside {
            display: block;
            @include grid-column(8);
            position: relative;
            .compacted & {
                display: none !important;
            }
            @include mobile() {
                display: none !important;
            }
        }

        .filesystem-resource-list {
            a {
                text-decoration: none;
            }
            li {
                @include clearfix();
                padding: 0.3em 0;
                border-bottom: 1px solid #999;
                &:last-of-type {
                    border-bottom: none;
                }
                &.active {
                    background-color: $brand;
                    color: #fff;
                    a {
                        color: #fff;
                    }
                }
            }
            .image {
                width: 15%;
                max-width: 38px;
                float: left;
                margin-right: 1em;
                img {
                    max-width: 100%;
                }
            }
            .resource-name {
                float: left;
                width: 70%;
                font-size: 13px;
                white-space: nowrap;
                overflow: scroll;
                small {
                    display: block;
                }
            }
            .resource-arrow {
                float: right;
            }
        }
        .filesystem-resource-icons {
            @include grid-container();
            @include grid-collapse;
            margin-top: 35px;
            li {
                position: relative;
                @include desktop() {
                    @include grid-column(2);
                    &:nth-of-type(2n+1), &:nth-of-type(3n+1), &:nth-of-type(4n+1), &:nth-of-type(6n+1) {
                        clear: none;
                    }
                    &:nth-of-type(6n+1) {
                        clear: both;
                    }
                }

                @media(max-width: 900px) {
                    @include grid-column(3);
                    &:nth-of-type(2n+1), &:nth-of-type(3n+1), &:nth-of-type(4n+1), &:nth-of-type(6n+1) {
                        clear: none;
                    }
                    &:nth-of-type(4n+1) {
                        clear: both;
                    }
                }

                @media(max-width: 600px) {
                    @include grid-column(4);
                    &:nth-of-type(2n+1), &:nth-of-type(3n+1), &:nth-of-type(4n+1), &:nth-of-type(6n+1) {
                        clear: none;
                    }
                    &:nth-of-type(3n+1) {
                        clear: both;
                    }
                }
                text-align: center;
                font-size: 13px;
                margin-bottom: 10px;
                line-height: 19px;
                padding-top: 1em;
                padding-bottom: 1em;
                padding-left: 0.5em;
                padding-right: 0.5em;
                transition: background 0.1s ease-in-out;
                &:hover, &.active {
                    background-color: #ebf2f6;
                    border-radius: $standardBorderRadius;
                }
                img {
                    max-height: 80px;
                    display: block;
                    margin: 0 auto 10px auto;
                }
                a {
                    text-decoration: none;
                }
            }
        }

        .filesystem-directory {

        }

        .filesystem-file {
            i {
                display: block;
                font-size: 50px;
                height: 80px;
                margin-bottom: 10px;
                color: #a9d5ec;
                padding-top: 17px;
            }
            img {
                border-radius: $standardBorderRadius;
            }
        }
    }

    .directory-counter, .version-counter {
        position: absolute;
        top: 15px;
        left: calc(50% - 12px + 44px);
        color: #fff;
        font-weight: 600;
        background-color: $red;
        border-radius: 50%;
        box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.3);
        width: 24px;
        padding: 2px;
        font-size: 11px;

        @media(max-width: 600px) {
            left: calc(50% - 12px + 30px);
        }
    }

    .file-breadcrumbs {
        float: left;
        a {
            font-weight: 500;
        }
        a::before {
            content: '>';
            font-weight: 400;
            display: inline-block;
            margin: 0 10px 0 8px;
        }
        a:first-of-type::before {
            display: none;
        }
        @include mobile() {
            float: none;
            display: block;
            text-align: center;
            width: 100%;
            margin-bottom: 15px;
        }
    }

    .action-bar .extra-actions {
        float: right;

        br {
            display: none;
        }

        a {
            margin-right: 15px;
        }
        a:last-of-type {
            margin-right: 0;
        }
        a.active {
            color: $brand;
        }

        @include mobile() {
            float: none;
            display: block;
            text-align: center;
            width: 100%;
            a:first-of-type, a:nth-of-type(2) {
                margin-bottom: 15px;
                display: inline-block;
            }

            a:nth-of-type(2) {
                margin-right: 0;
            }
            br {
                display: block;
            }
        }
    }

    .action-bar {
        margin-bottom: 15px;
        border-radius: $standardBorderRadius;
        padding: 0.5em 1em;
        background-color: #f5f5f5;
        @include clearfix;

        a {
            text-decoration: none;
            color: #6b8b9f;
            &:hover {
                color: $brand;
            }
        }
    }

    .action-bar-mobile {
        background-color: transparent;
        padding: 0;
        margin-bottom: 15px;
        @include clearfix;
        a {
            text-decoration: none;
            color: #6b8b9f;
            &:hover {
                color: $brand;
            }
        }
        .extra-actions {
            float: right;
            a {
                display: inline-block;
                margin-left: 2px;
                background-color: $brand;
                color: #FFF;
                padding: 0.2em 0.5em;
                border-radius: $standardBorderRadius;
                font-size: 16px;
                transition: all 0.1s ease-in-out;
                &:hover {
                    background-color: lighten($brand, 10);
                }
            }
        }
        .file-breadcrumbs {
            margin-bottom: 15px;
            border-radius: 0.3em;
            padding: 0.5em 1em;
            background-color: #f5f5f5;
            text-align: left;
            overflow-x: scroll;
            white-space: nowrap;
        }
        .search-area {
            text-align: left;
            float: left;
            width: 60%;
            position: relative;
            input {
                max-width: 70%;
                float: left;
            }
            a {
                float: left;
                margin-left: 5px;
            }
        }
    }

    aside > div > h1 {
        text-align: center;
        display: block;
    }

    h1.pad-left {
        padding-left: 1.5em;
    }

    aside > div {
        .sidebar-detail-icon {
            display: block;
            margin: 30px auto 45px;
            max-height: 80px;
        }
        .sidebar-detail-image {
            max-width: 90% !important;
            max-height: 500px;
        }
        .sidebar-detail-font-icon {
            display: block;
            margin: 30px auto 45px;
            font-size: 60px;
            text-align: center;
        }
    }

    .item-action-button {
        padding: 0.4em 0.8em;
        border-radius: $standardBorderRadius;
        color: #FFF;
        text-decoration: none;
        float: right;
        clear: both;
        margin-top: 1em;
        background-color: $brand;
        .fa {
            margin-right: 6px;
        }
        &.warning {
            background-color: $red;
        }
    }

    .search-area {
        @include clearfix();
        div {
            float: right;
            width: 300px;
            text-align: right;
            @include mobile() {
                text-align: center;
                width: 100%;
                float: none;
                display: block;
            }
        ;
        }
        input {
            max-width: 250px;
            display: inline-block;
            @include mobile() {
                max-width: 80%;
            }
        ;
        }
        a {
            display: inline-block;
            margin-left: 10px;
            background-color: $brand;
            color: #FFF;
            padding: 0.2em 0.5em;
            border-radius: $standardBorderRadius;
            font-size: 16px;
            transition: all 0.1s ease-in-out;
            &:hover {
                background-color: lighten($brand, 10);
            }
        }
    }

    .back-to-search-results-button, .back-to-listings-button {
        color: $brand;
        transition: all 0.1s ease-in-out;
        &:hover {
            color: lighten($brand, 10);
        }
        position: absolute;
        top: 1em;
        left: 1em;
        font-size: 16px;
        z-index: 1000;
    }

    .changelog {
        h4 {
            font-size: 14px;
            padding-top: 2px;
            color: #5d5d5d;
            font-weight: 500;
            margin-bottom: 5px;
        }
        p {
            font-size: 12px;
        }
    }

    .filesystem .hidden-compacted {
        display: none;
    }

    .filesystem .visible-compacted {
        display: block !important;
    }

    .directory-element, .file-element {
        transition: all 0.1s ease-in-out;
    }

    .scroller {
        position: relative;
        /*overflow-x: hidden;*/
        -webkit-overflow-scrolling: touch;
        height: calc(100vh - 275px);
        /*max-height: calc(100vh - 275px);*/
        /*overflow-y: scroll;*/
    }

</style>
